import { CommonOption } from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";

export const rePrintFields = (
  REASON_FOR_REPRINT_OPTIONS: CommonOption[],
): FormFieldConfig[] => [
  {
    name: "reason",
    label: "Reason for Reprint",
    type: "select",
    options: REASON_FOR_REPRINT_OPTIONS,
    placeholder: "Select Reason...",
    required: true,
    rules: { required: "Reason is required" },
  },
  {
    name: "comments",
    label: "Additional Comments",
    type: "textarea",
    placeholder: "Optional explanation...",
    required: false,
     rules: {
         maxLength: {
            value: 250,
            message: "Maximum 250 characters allowed",
          },
      },
  },
];
